import * as CmsActions from './cms-actions';
import * as CmsReducer from './cms-reducer';

export {
    CmsActions,
    CmsReducer
};
